
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 1.6h-.008A14.245 14.245 0 007.9 4.091a14.499 14.499 0 00-5.132 6.211 14.211 14.211 0 00-.859 2.703 14.622 14.622 0 000 5.992A14.248 14.248 0 004.091 24.1a14.499 14.499 0 006.211 5.132c.861.372 1.765.661 2.703.859a14.622 14.622 0 005.992 0 14.243 14.243 0 005.104-2.182 14.499 14.499 0 005.132-6.211c.372-.861.661-1.765.859-2.703a14.622 14.622 0 000-5.992A14.248 14.248 0 0027.91 7.9a14.499 14.499 0 00-6.211-5.132 14.22 14.22 0 00-2.704-.859 14.504 14.504 0 00-2.99-.309H16zm1.59 21.458c0 .03-.003.059-.007.087a.443.443 0 01-.144.261.322.322 0 01-.193.072H14.719a.276.276 0 01-.135-.034.322.322 0 01-.108-.088.555.555 0 01-.095-.21.494.494 0 01-.007-.087v-2.34a.497.497 0 01.102-.298.394.394 0 01.108-.088.275.275 0 01.128-.032h2.534a.276.276 0 01.135.034.322.322 0 01.108.088.555.555 0 01.074.132.494.494 0 01.027.165v2.339zm.404-11.528l-.074.806-.533 5.645a.414.414 0 01-.07.235.42.42 0 01-.105.113.375.375 0 01-.224.072h-2.012a.375.375 0 01-.224-.072.393.393 0 01-.105-.112.42.42 0 01-.06-.148.407.407 0 01-.009-.087l-.43-4.838-.068-.806-.072-.806V8.944a.414.414 0 01.07-.235.42.42 0 01.105-.113.375.375 0 01.224-.072h3.19a.375.375 0 01.224.072.41.41 0 01.142.182.504.504 0 01.033.164v2.587z","fill":"#ffb000"}})])
          )
        }
      }
    